import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Blog_Listing = ({ categorySlug, topicSlug }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const blogsPerPage = 10;

  useEffect(() => {
    const fetchBlogs = async () => {
      const endpoint = topicSlug
        ? `https://blogs.vananiassociates.com/api/blogs/categories/${categorySlug}/${topicSlug}?page=${currentPage}&per_page=${blogsPerPage}`
        : categorySlug
        ? `https://blogs.vananiassociates.com/api/blogs/categories/${categorySlug}?page=${currentPage}&per_page=${blogsPerPage}`
        : `https://blogs.vananiassociates.com/api/blogs/categories?page=${currentPage}&per_page=${blogsPerPage}`;

      try {
        setLoading(true);
        const response = await fetch(endpoint);
        if (!response.ok) {
          throw new Error('Failed to fetch blogs');
        }
        const data = await response.json();
        setBlogs(data.data || []);
        setTotalPages(data.last_page || 1);
        setSelectedBlog(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [categorySlug, topicSlug, currentPage]);

  const handleLinkClick = async (e, blogSlug) => {
    e.preventDefault(); // Prevent immediate navigation

    try {
      const apiEndpoint = `https://blogs.vananiassociates.com/api/blogs/detail/${blogSlug}`; // Replace with actual API
      const response = await fetch(apiEndpoint);

      if (!response.ok) {
        throw new Error('Failed to log click');
      }

      const blogDetails = await response.json();
      setSelectedBlog(blogDetails);
    } catch (error) {
      console.error('Error logging click:', error);
    }
  };
  

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleBackToListing = () => {
    setSelectedBlog(null); // Reset to show blog listing
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!blogs.length) return <p>No blogs available.</p>;

  // Show blog details if a blog is selected
  // if (selectedBlog) {
  //   return (
  //     <div className="container">
  //       <div className='blog_details_wrap'>
  //         <div className="img_wrap">
  //           <img
  //             className='img_width rounded-2' src={selectedBlog.banner || 'https://via.placeholder.com/800'}
  //             alt={selectedBlog.title}
  //           />
  //         </div>
  //         <h1 className='blog_main_title'>{selectedBlog.title}</h1>
  //         <div className='social_wrap text-center mt-4 mb-4'>
  //           <ul className='d-flex m-0 p-0 list-unstyled justify-content-center'>
  //             <p className='mb-0'>Share.</p>
  //             <li><Link to=''>FACEBOOK</Link></li>
  //             <li><Link to=''>TWITTER</Link></li>
  //             <li><Link to=''>PINTEREST</Link></li>
  //           </ul>
  //         </div>
  //         <p dangerouslySetInnerHTML={{ __html: selectedBlog.content }}></p>
  //         <button className="rounded-pill btn solid_btn blog_btn" onClick={handleBackToListing}>
  //              <i class="fas fa-chevron-left"></i> Back to Blogs
  //         </button>
  //       </div>
  //     </div>
  //   );
  // }

  // Blog List Design
  return (
    <div className="blog_listing_wrapper row">
      {blogs.map((blog) => (
        <div className="col-md-6" key={blog.slug}>
          <Link to={`/blog/${blog.slug}`} className="text-decoration-none">
            <div className="blog_column mb-4">
              <img
                className="img_width"
                src={blog.banner || 'https://via.placeholder.com/150'}
                alt={blog.title}
              />
              <div className="column">
                <h5>{blog.title}</h5>
                <div
                  className="mb-3"
                  dangerouslySetInnerHTML={{
                    __html: blog.content.substring(0, 200).replace(/<\/p>$/, '...</p>'),
                  }}
                ></div>
                <div className="inr_clm d-flex justify-content-between">
                  <p className="date m-0">
                    <i className="far fa-clock"></i>{' '}
                    {new Date(blog.created_at).toLocaleDateString()}
                  </p>
                  <p className="name m-0">
                    <i className="far fa-user"></i> {blog.author}
                  </p>
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
      
      {totalPages > 1 && (
        <nav aria-label="Pagination">
        <ul className="pagination justify-content-center mt-2">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Previous"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
          </li>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <li
              key={page}
              className={`page-item ${page === currentPage ? 'active' : ''}`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label="Next"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
      )
        
      }
      
    </div>
  );
  
};

export default Blog_Listing;
